import { Status, Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { dataLockerLandingPageSelectedTabAtom } from '@/atoms/dataLocker/landingPage';

export const FilterSetTableStatus = () => {
  const { t } = useTranslation(['status', 'navigation']);
  const selectedTab = useAtomValue(dataLockerLandingPageSelectedTabAtom);
  const isExplorePage = !!useMatch('/:locale/data-locker/');

  const explorePage = t(`crossPlatform.secondary.${selectedTab === 'players' ? 'playerScout' : selectedTab}`, {
    ns: 'navigation',
  });

  const description = t(`filtersTable.noData.${isExplorePage ? 'exploreDescription' : 'description'}`, {
    page: explorePage,
  });

  return (
    <div className="h-[322px] border border-canvas-primary-main">
      <Status title={t('filtersTable.noData.title')} type="info">
        <Typography variant="bodyRegular">{description}</Typography>
      </Status>
    </div>
  );
};
